module.exports = __webpack_public_path__ + "static/img/pic-home-banner.c62c5c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/pic-home-banner.png
// module id = 6+jm
// module chunks = 1